import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './@shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatDialogModule } from '@angular/material/dialog';
import { ActionComponent } from './@shared/action/action.component';
import { AppListDialogComponent } from './@shared/app-list-dialog/app-list-dialog.component';
import { TitleCasePipe } from './@shared/pipe/title-case.pipe';
import { ListPrintPipe } from './@shared/pipe/list-print.pipe';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoaderDirective } from './@shared/directives/loader.directive';
import { AuthInterceptor } from './@auth/auth-material/auth.interceptor';
import { NgChartsModule } from 'ng2-charts';
import { TaskOrderAppListDialogComponent } from './@shared/task-order-app-list-dialog/task-order-app-list-dialog.component';
import { TaskOrderPdfComponent } from './task-order-pdf/task-order-pdf.component';
import { CandidateFormComponent } from './candidate-form/candidate-form.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MediaComponent } from './media/media.component';
import { DateInterceptor } from './@shared/date.interceptor';
import { PermissionService } from './@auth/auth-material/permission.service';
import { AuthService } from './@auth/auth-material/auth.service';
import { DisableOnClickDirective } from './@shared/directives/disable-on-click.directive';
import { ButtonDisableInterceptor } from './@auth/auth-material/button-disable.interceptor';
import { SearchFilterComponent } from '../app/@shared/components/search-filter/search-filter.component';
import { AnnouncementDialogComponent } from './@shared/announcement/announcement-dialog/announcement-dialog.component';
import { ReportComponent } from './@shared/report/report.component';

export function preloadPermissions(permissionService: PermissionService) {
  return () => permissionService.refreshPermissionsBeforeAppStart();
}
export function initRbac(rbac: PermissionService) {
  return () => {
    if (rbac.hasToken()) {
      return rbac.loadPermissions();
    }
    return Promise.resolve();
  };
}

@NgModule({ declarations: [
        AppComponent,
        AppListDialogComponent,
        TitleCasePipe,
        ListPrintPipe,
        LoaderDirective,
        TaskOrderAppListDialogComponent,
        TaskOrderPdfComponent,
        CandidateFormComponent,
        MediaComponent,
        DisableOnClickDirective,
        AnnouncementDialogComponent,
        ReportComponent,
    ],
    exports: [
        DisableOnClickDirective
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        CKEditorModule,
        MatDialogModule,
        MatDialogModule,
        ActionComponent,
        MatPaginatorModule,
        LoadingBarModule,
        SearchFilterComponent,
        LoadingBarHttpClientModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),
        NgChartsModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ButtonDisableInterceptor, multi: true },
        {
            provide: APP_INITIALIZER,
            useFactory: initRbac,
            deps: [PermissionService, AuthService],
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
